import { AuthorizationResponsePayload } from "@sphereon/ssi-sdk.siopv2-oid4vp-common";
import { CredentialMapper } from "@sphereon/ssi-types";

export interface IPayloadProps {
  payload: AuthorizationResponsePayload;
  signalIfValid: (isValid: boolean) => void;
  authenticateUser?: () => void;
  data?: any;
  useMySSIOnly?: boolean;
  showMySSIOnly?: boolean;
}

export class PayloadSubjectUtils {
  getSubjects(payload: AuthorizationResponsePayload, index: number = 0): any {
    if (payload) {
      const presentation = CredentialMapper.toWrappedVerifiablePresentation(
        Array.isArray(payload.vp_token)
          ? payload.vp_token[0]
          : payload.vp_token!,
      );
      const subjects =
        presentation?.presentation?.verifiableCredential[index].credential
          .credentialSubject!; // Although rare, a VC can have more than one subject
      return subjects;
    }
    return null;
  }
}
